import { render, staticRenderFns } from "./SoldierStrive.vue?vue&type=template&id=4a772e6e"
import script from "./SoldierStrive.vue?vue&type=script&lang=js"
export * from "./SoldierStrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports